import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper/modules";
import "swiper/css";
import WatchSVG from "../../../../../svgs/WatchSVG";
import Facility1 from "../../../../../pngs/Facility1.png";
import Facility2 from "../../../../../pngs/Facility2.png";
import Facility3 from "../../../../../pngs/Facility3.png";

const Facilities = () => {
  return (
    <div className="w-full h-[700px] flex flex-col justify-center items-center mt-4 lg:mt-6 border-y border-stroke1 overflow-y-auto [&>div]:w-full relative">
      <span className="absolute right-0 top-0 w-16 h-full bg-gradient-to-l from-[#09090B] to-transparent z-50"></span>
      <h2 className="mt-10 text-text3 text-[20px] mini:text-[24px] md:text-[32px]">
        The facilities it provides you
      </h2>
      <Swiper
        modules={[Mousewheel, Pagination]}
        direction="vertical"
        speed={800}
        pagination={{ clickable: true }}
        mousewheel={{ thresholdDelta: 50, sensitivity: 1 }}
        scrollbar={{ draggable: true }}
        className="pt-24"
      >
        <SwiperSlide className="!h-[470px]">
          <div className="w-full flex items-center justify-between">
            <div className="flex flex-col gap-2 px-5 lg:px-10 w-[60%] ">
              <h3 className="text-text2 max-w-[400px] text-[10px] mini:text-[12px] sm:text-[15px] lg:text-[20px]">
                The possibility of using the opinions and statements of
                prominent professors in writing all kinds of documents and bills
              </h3>
              <h2 className="text-text3 text-[12px] sm:text-[16px] lg:text-[22px] flex items-center self-start gap-2 cursor-pointer">
                Watch a demo <WatchSVG />
              </h2>
            </div>
            <div className="flex flex-col self-start gap-5 justify-between w-[40%]">
              <img src={Facility1} alt="" />
            </div>
          </div>
        </SwiperSlide>
        
        <SwiperSlide>
          <div className="w-full flex items-center justify-between">
            <div className="flex flex-col gap-2 px-5 lg:px-10 w-[60%] ">
              <h3 className="text-text2 max-w-[400px] text-[10px] mini:text-[12px] sm:text-[15px] lg:text-[20px]">
                Quick access to your client and voice and video communication,
                etc., directly through online chat, which is provided to you in
                the dashboard and Ai-chat panel.
              </h3>
              <h2 className="text-text3 text-[12px] sm:text-[16px] lg:text-[22px] flex items-center self-start gap-2 cursor-pointer">
                Watch a demo <WatchSVG />
              </h2>
            </div>
            <div className="flex flex-col self-start gap-5 justify-between w-[40%]">
              <img src={Facility2} alt="" className="" />
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="w-full flex items-center justify-between">
            <div className="flex flex-col gap-2 px-5 lg:px-10 w-[60%] ">
              <h3 className="text-text2 max-w-[400px] text-[10px] mini:text-[12px] sm:text-[15px] lg:text-[20px]">
                Quick access to your client and voice and video communication,
                etc., directly through online chat, which is provided to you in
                the dashboard and Ai-chat panel.
              </h3>
              <h2 className="text-text3 text-[12px] sm:text-[16px] lg:text-[22px] flex items-center self-start gap-2 cursor-pointer">
                Watch a demo <WatchSVG />
              </h2>
            </div>
            <div className="flex flex-col self-start gap-5 justify-between w-[40%]">
              <img src={Facility3} alt="" className="" />
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Facilities;
